function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".DataConnection-1{fill:#16224a;}.DataConnection-2{fill:#ffbe54;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "DataConnection-1",
  d: "M581,527.52c0,15.51,44.09,28.12,98.49,28.12S778,543,778,527.52s-44.1-28.15-98.49-28.15S581,512,581,527.52Zm0,22.53v33.74c0,15.51,44.09,28.15,98.49,28.15S778,599.3,778,583.79V550.05c-28.13,18.9-89.64,19.66-98.49,19.66S609.11,569,581,550.05Zm0,56.29v33.71c0,15.55,44.09,28.17,98.49,28.17S778,655.6,778,640.05V606.34C749.83,625.24,688.32,626,679.47,626S609.11,625.24,581,606.34Zm0,56.28v33.74c0,15.51,44.09,28.13,98.49,28.13S778,711.87,778,696.36V662.62c-28.13,18.9-89.64,19.66-98.49,19.66S609.11,681.52,581,662.62ZM330.55,499.37c-54.4,0-98.51,12.61-98.51,28.15s44.11,28.12,98.51,28.12S429,543,429,527.52,384.93,499.37,330.55,499.37ZM232,550.05v33.74c0,15.51,44.11,28.15,98.51,28.15S429,599.3,429,583.79V550.05c-28.13,18.9-89.63,19.66-98.48,19.66S260.17,569,232,550.05Zm0,56.29v33.71c0,15.55,44.11,28.17,98.51,28.17S429,655.6,429,640.05V606.34C400.9,625.24,339.4,626,330.55,626S260.17,625.24,232,606.34Zm0,56.28v33.74c0,15.51,44.11,28.13,98.51,28.13S429,711.87,429,696.36V662.62c-28.13,18.9-89.63,19.66-98.48,19.66S260.17,681.52,232,662.62ZM505.7,341.77c54.4,0,98.5-12.57,98.5-28.13s-44.1-28.13-98.5-28.13-98.5,12.61-98.5,28.13S451.29,341.77,505.7,341.77Zm0,56.31c54.4,0,98.5-12.63,98.5-28.14V336.18c-28.15,18.9-89.66,19.68-98.5,19.68s-70.33-.78-98.5-19.68v33.76C407.2,385.45,451.29,398.08,505.7,398.08Zm0,56.27c54.4,0,98.5-12.62,98.5-28.12V392.45c-28.15,18.9-89.66,19.7-98.5,19.7s-70.33-.8-98.5-19.7v33.78C407.2,441.73,451.29,454.35,505.7,454.35Zm0,56.27c54.4,0,98.5-12.62,98.5-28.12V448.75c-28.15,18.9-89.66,19.67-98.5,19.67s-70.33-.77-98.5-19.67V482.5C407.2,498,451.29,510.62,505.7,510.62Z",
  transform: "translate(-232.04 -285.51)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "DataConnection-2",
  d: "M505,601.55v15a40,40,0,0,1,33.3,62.1l-10.9-10.9a25.08,25.08,0,0,0-22.4-36.2v15l-22.5-22.5,22.5-22.5",
  transform: "translate(-232.04 -285.51)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "DataConnection-2",
  d: "M505,711.55v-15a40,40,0,0,1-33.3-62.1l10.9,10.9a25.08,25.08,0,0,0,22.4,36.2v-15l22.5,22.5L505,711.55",
  transform: "translate(-232.04 -285.51)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "DataConnection-2",
  d: "M330.54,368.4v15a40,40,0,0,1,33.3,62.1l-10.9-10.9a25.08,25.08,0,0,0-22.4-36.2v15L308,390.9l22.5-22.5",
  transform: "translate(-232.04 -285.51)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "DataConnection-2",
  d: "M330.54,478.4v-15a40,40,0,0,1-33.3-62.1l10.9,10.9a25.08,25.08,0,0,0,22.4,36.2v-15L353,455.9l-22.5,22.5",
  transform: "translate(-232.04 -285.51)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "DataConnection-2",
  d: "M679.47,368.4v15a40,40,0,0,1,33.3,62.1l-10.9-10.9a25.08,25.08,0,0,0-22.4-36.2v15L657,390.9l22.5-22.5",
  transform: "translate(-232.04 -285.51)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "DataConnection-2",
  d: "M679.47,478.4v-15a40,40,0,0,1-33.3-62.1l10.9,10.9a25.08,25.08,0,0,0,22.4,36.2v-15L702,455.9l-22.5,22.5",
  transform: "translate(-232.04 -285.51)"
});

var SvgDataConnection = function SvgDataConnection(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "DataConnection",
    "data-name": "DataConnection 1",
    viewBox: "0 0 545.91 438.97",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDataConnection, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DataConnection.272e934e.svg";
export { ForwardRef as ReactComponent };